import { render, staticRenderFns } from "./SetCurrentClientInput.vue?vue&type=template&id=6b4454c6&"
import script from "./SetCurrentClientInput.vue?vue&type=script&lang=js&"
export * from "./SetCurrentClientInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports